export const FILTER_MISMATCH_TAG = 'Filter Mismatch';

// Reason strings the API appends after the 'Filter Mismatch' tag. Kept as a
// whitelist so unrelated tags never render as mismatch reasons.
export const FILTER_MISMATCH_REASONS = new Set<string>([
  'Not Matching Air Handlers',
  'Out of Stock',
  'Not on Sale',
  'Below Min Price',
  'Above Max Price',
  "Doesn't Match Equipment Filters"
]);

export function extractFilterMismatchReasons(
  tags: readonly string[]
): string[] {
  const idx = tags.indexOf(FILTER_MISMATCH_TAG);
  if (idx === -1) return [];
  return tags.slice(idx + 1).filter((t) => FILTER_MISMATCH_REASONS.has(t));
}
